import { EntityType, Module } from "@/constants";

import { SERVICE_NAME } from "@/config/serviceNames";
import { requests } from ".";

interface TransferDomainParams {
  locationId: string;
  domain: string;
  targetLocationId: string;
}

const DomainService = {
  transferDomain: (body: TransferDomainParams) =>
    requests(SERVICE_NAME.DOMAINS_API)
      .log({
        entityId: body.locationId,
        entityType: EntityType.LOCATION,
        module: Module.LC_DOMAIN,
      })
      .post("reselling/transfer-domain-to-different-location", body),
};

export default DomainService;
